import { fetchAPIColumnOptionsAPI, fetchTableFormAPI } from "../infrastructure/table-appendix.api";
import type { APIColumnOption, TableForm } from "../infrastructure/table-appendix.formatter";

export function fetchTableForm({
  referenceId,
  tableId,
}: { referenceId: number; tableId: number }): Promise<TableForm[]> {
  return fetchTableFormAPI({ referenceId, tableId });
}

export function fetchAPIColumnOptions(url: string): Promise<APIColumnOption[]> {
  return fetchAPIColumnOptionsAPI(url);
}
